import React from 'react';

import { Link } from 'react-router-dom';

import { orgRoute } from '../web-routes';

import { getCustomerLogoPath } from '../util/get-customer-logo-path';

type InputProps = {
  org: TeamEngineAccountOrg;
};

export const AccountsListOrgLink = ({ org }: InputProps) => (
  <Link
    to={orgRoute(org.org_id)}
    onClick={(e) => e.stopPropagation()}
    className="u-display-flex u-hover-highlight u-cursor-pointer u-alignItems-center u-borderRadius-3 u-margin-bottom-sm u-padding-sm"
    style={{ border: '1px solid #e0e0e0' }}
  >
    <div
      style={{ width: '50px', height: '50px' }}
      className="u-flex-center u-justifyContent-center"
    >
      <img
        src={getCustomerLogoPath(org)}
        className="u-display-block"
        style={{
          maxWidth: '50px',
          maxHeight: '50px',
        }}
        alt={`${org.name} logo`}
      />
    </div>
    <div className="u-margin-left-lg">{org.name}</div>
  </Link>
);
